import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth-guards/auth.guard';
import { XgsGuardGuard } from 'app/auth/auth-guards/xgs-guard.guard';
import { GSOAMISAASComponent } from './gso-ami-saas/gso-ami-saas.component';

const routes: Routes = [
  {
    path: '',
    component: GSOAMISAASComponent,
    pathMatch: 'full',
    canActivate: [XgsGuardGuard, AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagedServicesRoutingModule { }
